import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlackIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	"aria-hidden": "true",
	viewBox: "0 0 127 127",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#e01e5a",
			d: "M27.2 80C27.2 87.3 21.3 93.2 14 93.2C6.69999 93.2 0.799988 87.3 0.799988 80C0.799988 72.7 6.69999 66.8 14 66.8H27.2V80ZM33.8 80C33.8 72.7 39.7 66.8 47 66.8C54.3 66.8 60.2 72.7 60.2 80V113C60.2 120.3 54.3 126.2 47 126.2C39.7 126.2 33.8 120.3 33.8 113V80Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#36c5f0",
			d: "M47 27C39.7 27 33.8 21.1 33.8 13.8C33.8 6.50001 39.7 0.600006 47 0.600006C54.3 0.600006 60.2 6.50001 60.2 13.8V27H47ZM47 33.7C54.3 33.7 60.2 39.6 60.2 46.9C60.2 54.2 54.3 60.1 47 60.1H13.9C6.60001 60.1 0.700012 54.2 0.700012 46.9C0.700012 39.6 6.60001 33.7 13.9 33.7H47Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2eb67d",
			d: "M99.9 46.9C99.9 39.6 105.8 33.7 113.1 33.7C120.4 33.7 126.3 39.6 126.3 46.9C126.3 54.2 120.4 60.1 113.1 60.1H99.9V46.9ZM93.3 46.9C93.3 54.2 87.4 60.1 80.1 60.1C72.8 60.1 66.9 54.2 66.9 46.9V13.8C66.9 6.50001 72.8 0.600006 80.1 0.600006C87.4 0.600006 93.3 6.50001 93.3 13.8V46.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ecb22e",
			d: "M80.1 99.8C87.4 99.8 93.3 105.7 93.3 113C93.3 120.3 87.4 126.2 80.1 126.2C72.8 126.2 66.9 120.3 66.9 113V99.8H80.1ZM80.1 93.2C72.8 93.2 66.9 87.3 66.9 80C66.9 72.7 72.8 66.8 80.1 66.8H113.2C120.5 66.8 126.4 72.7 126.4 80C126.4 87.3 120.5 93.2 113.2 93.2H80.1Z"
		})
	]
});
export default SvgSlackIcon;
